import { render, staticRenderFns } from "./VariacoesProduto.vue?vue&type=template&id=03372e75&scoped=true&"
import script from "./VariacoesProduto.vue?vue&type=script&lang=js&"
export * from "./VariacoesProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03372e75",
  null
  
)

export default component.exports